export default "__VITE_ASSET__Bz4BDN5L__"